<template>
  <div class="team-page">
    <div class="tab-box">
      <ul class="tab-btn-list">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.isActive}">
          <router-link :to="{name: tab.name}">
            {{tab.title}}
          </router-link>
        </li>
      </ul>
    </div>
    <div v-if="seasonType.playerRanking" class="rank-div">
      <PlayerItem :title="'팀 득점 랭킹'" :list-data="scoreList" />
      <div class="division-line"></div>
      <PlayerItem :title="'팀 도움 랭킹'" :list-data="assistList" />
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>
import {comma, sortData} from '@/lib';
import PlayerItem from '@/components/Match/PlayerItem.vue';
import dayjs from "dayjs";
import PageComingSoon from '@/components/Common/PageComingSoon';

export default {
  name: 'PlayerRanking',
  components: {
    PlayerItem, PageComingSoon
  },
  data() {
    return {
      tabList: [],
      scoreList: [],
      assistList: [],
      thisyear: dayjs().format('YYYY'),
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });

    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      return x.meta && x.meta.title;
    });

    Object.entries(subMenuList).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name ? true : false
      }
      this.tabList.push(result);
    });
  },
  mounted () {
    this.getGoalRanking();
    this.getAssistRanking();
  },
  methods: {
    async getGoalRanking() {

      const {data} = await this.$http.get(`/player/season_rank?type=goal&year=${this.thisyear}`);
      if(data.success) {
        this.scoreList = data.data.slice(0, 5)
      }
    },
    async getAssistRanking() {
      const {data} = await this.$http.get(`/player/season_rank?type=assist&year=${this.thisyear}`);
      if(data.success) {
        this.assistList = data.data.slice(0, 5)
      }
    },
    sortData
  }
}
</script>
